import { useTranslation } from 'react-i18next';

export const keyPrefix = 'duplicate_list';
export const useDuplicateListTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    toast_success: 'Список успешно создан',
    toast_error: 'Не удалось создать список',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    toast_success: 'The list has been successfully created',
    toast_error: 'Failed to create list',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    toast_success: 'La lista se ha creado correctamente',
    toast_error: 'No se pudo crear la lista',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    toast_success: 'A lista foi criada com sucesso',
    toast_error: 'Falha ao criar a lista',
  },
}) : {}) as Record<string, unknown>;
